import { gql } from '@apollo/client';
/**
 * @fragment CurrencyFragment
 * @since 1.0.0
 */
export const CurrencyFragment = gql `
  fragment CurrencyFragment on Currency {
    id
    title
    code
    rate
    primary
    enabled
  }
`;
